/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './footer.css'
import { FaLinkedin } from "react-icons/fa";
import { FaSquareGithub } from "react-icons/fa6";


const footer = () => {
  return (
   <footer>
      <a href="#" className='footer_logo'>CHIDINMA</a>

      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>        
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer_socials">
        <a href="https://www.linkedin.com/in/chidinma-ekuma/"><FaLinkedin/></a>
        <a href="https://github.com/Chidinma6"><FaSquareGithub/></a>
      </div>

      <div className="footer_copyright">
        <small>&copy; Chidinma. All rights reserved.</small>
      </div>
      
   </footer>
  )
}

export default footer